import React from 'react';
import { translate } from 'react-i18next';

import EsotericRadioButton from 'components/EsotericRadioButton.js';
import FancyCheckbox from 'components/account/FancyCheckbox.js';
import ValidationMessage from 'components/account/ValidationMessage.js';

class NotificationChoices extends React.Component {
  constructor(props) {
    super(props);

    this.handleSettingChange = this.handleSettingChange.bind(this);
    this.toggleSetting = this.toggleSetting.bind(this);
    this.contactInfoCallbackHandler = this.props.contactInfoCallbackHandler.bind(this);
    this.validationMessage = this.validationMessage.bind(this);
    this.state = {
      enabled: false,
      validationWarnings: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      enabled: nextProps.enabled,
      [nextProps.notificationType]: nextProps.enabled,
    });
  }

  toggleSetting(preference, value) {
    this.setState({
      enabled: value,
    });
    this.props.toggleSetting(preference, value);
  }

  handleSettingChange(preference, value) {
    this.setState({
      value,
      name: preference,
    });
    this.props.handleSettingChange(preference, value);
  }

  validateContactRequirements(callout_preference) {
    let disabled = false;
    if (callout_preference == 'phone' || callout_preference == 'sms') {
      disabled = (
        (this.props.user[0] && !this.props.user[0].data.phone_number) ||
        (this.props.user.phone_number === '' || this.props.user.phone_number === null)
      );
    }
    return disabled;
  }

  validationMessage(valid, element) {
    if (valid && element != 'sms') {
      return;
    }

    if (valid && element == 'sms') {
      return (
        <div className="message hint">
          {this.props.t('NotificationChoices.rates_may_apply')} 
        </div>  
      );
    }

    return (
      <div className="message hint">
        <span>{this.props.t('NotificationChoices.enter_valid_phone')} </span>
        <ValidationMessage
          onClickHandler={this.props.contactInfoCallbackHandler}
          activePage={this.props.activePage}
          section="contact"
          text={this.props.t('NotificationChoices.contact_info')}
        />
      </div>
    );
  }

  validateSettability(element) {
    if (element == 'email' || element == 'push') {
      return false;
    }
    return this.validateContactRequirements(element);
  }

  render() {
    const currentPreference = this.props.calloutPreferences;
    const { settings, user } = this.props;
    let checked = false;
    const currentValue = this.props.currentPreference;
    let optionsClass = 'notificationOptions';

    if (!this.state.enabled) {
      optionsClass += ' hide';
    }

    // Advanced call-outs (what this component renders) are a separate,
    // older feature from the multi-format notification lock and stay fully
    // employee-controlled regardless of it -- Product: "the lock must not
    // change what channels a call-out is sent on". No lock-aware
    // disabling/display here on purpose.
    const settingName = `${this.props.notificationType}_methods`;
    const notificationOptions = this.props.validOptions.map(function (option) {
      checked = currentValue == option;
      const disabled = this.validateSettability(option);
      const message = this.validationMessage(!disabled, option);
      return (
        <div key={_.uniqueId()}>
          <EsotericRadioButton
            onClickHandler={this.props.contactInfoCallbackHandler}
            disabled={disabled}
            onSettingsChange={this.handleSettingChange.bind(this)}
            checked={checked}
            user={user}
            currentPreference={currentPreference}
            preference={option}
            settings={settings}
            name={settingName}
          />

          <div className="validation-message">{message}</div>
        </div>
      );
    }, this);

    return (
      <div className="notificationOptionCluster">
        <div className="primaryToggle">
          <FancyCheckbox
            disabled={false}
            label={this.props.label}
            checked={this.props.enabled}
            setting={this.props.notificationType}
            toggleSetting={this.toggleSetting.bind(this)}
          />
        </div>
        <div className={optionsClass}>{notificationOptions}</div>
      </div>
    );
  }
}

export default translate()(NotificationChoices);
